/* @flow */

import React from 'react';
import Styled from 'styled';
import defaultStyles from './vertical-separator-view.scss';

@Styled(defaultStyles)
class VerticalSeparatorView extends React.PureComponent {
    render() {
        const { styles } = this.props;

        return (
            <span className={styles.verticalSeparator}>
                <span className={styles.separator} />
            </span>
        );
    }
}

export default VerticalSeparatorView;
